import { render, staticRenderFns } from "./Coursepassed.vue?vue&type=template&id=442c8fa5"
import script from "./Coursepassed.vue?vue&type=script&lang=js"
export * from "./Coursepassed.vue?vue&type=script&lang=js"
import style0 from "./Coursepassed.vue?vue&type=style&index=0&id=442c8fa5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports